import { GradientIcon, MultiVideoCameraGrowIcon } from '@sparemin/blockhead';
import * as React from 'react';

import {
  PaidSubscriptionHeader,
  proGrowFeatures,
} from '../../components/PaidSubscription';
import { block } from './utils';

const ProGrowSubscriptionHeader: React.FC = () => {
  return (
    <PaidSubscriptionHeader
      title="Headliner Pro + Grow"
      icon={
        <div className={block('icon-container')}>
          <GradientIcon>
            <MultiVideoCameraGrowIcon className={block('icon')} />
          </GradientIcon>
        </div>
      }
      className={block('header')}
    >
      <PaidSubscriptionHeader.Features features={proGrowFeatures} />
    </PaidSubscriptionHeader>
  );
};

export default ProGrowSubscriptionHeader;
